import { type FunctionComponent } from 'react';
import { Menu } from '../../Menu/Menu';

export type HeaderProps = {};

export const Header: FunctionComponent<HeaderProps> = () => {
  return (
    <div>
      <Menu />
    </div>
  );
};
